import React from 'react';

import { initializeApp } from 'firebase/app';

var config = {
    apiKey: "AIzaSyBgmpvcWpDNjpCKZa3nc0iVt038_rxZRZI",
    authDomain: "greenlight-dc-unlock-mls.firebaseapp.com",
};

export const FirebaseAppProvider = ({ children }: React.PropsWithChildren<{}>) => {
    initializeApp(config);

    return <>{children}</>;
};